import { render, staticRenderFns } from "./ContactEdit.vue?vue&type=template&id=eea56a8a&scoped=true"
import script from "../controllers/ContactEdit.ts?vue&type=script&lang=ts&external"
export * from "../controllers/ContactEdit.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea56a8a",
  null
  
)

export default component.exports